export default "__VITE_ASSET__CLivEfNB__"